"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegafootTranslate = void 0;
exports.defaultMegafootTranslate = {
    clientServices: 'Client Services',
    buy: 'Buy',
    rent: 'Rent',
    list: 'List',
    ourExclusive: 'Our Exclusives',
    agents: 'Agents',
    findAnAgent: 'Find an Agent',
    joinUsAsAgent: 'Join us as Agent',
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    executiveTeam: 'Executive Team',
    ourTeam: 'Property Agents',
    testimonial: 'Testimonials',
    inThePress: 'In The Press',
    resources: 'Resources',
    newsAndInsights: 'News and Insights',
    askAnAgent: 'Ask An Agent',
    guides: 'Guides',
    mortgageCalculator: 'Mortgage Calculator',
    support: 'Support',
    faq: 'FAQ',
    contactUs: 'Contact Us',
    sitemap: 'Sitemap',
    okaycomApp: 'OKAY.COM App',
    letsConnect: 'Let\'s Connect',
    address: '15/F, Wilson House, 19-27 Wyndham St., Central, Hong Kong',
    phone: '+852 2102 0888',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and Conditions',
    companyName: 'Okay Property Agency Limited',
    eaaLicense: 'EAA License Number',
    eaaLicenseNumber: 'C-036846',
    allRightReserved: 'All Rights Reserved',
    appIosText: 'OKAY.COM - iOS App Store',
    appAndroidText: 'OKAY.COM - Android Play Store',
    subscribePlaceholder: 'Your Email',
    subscribeTitle: 'Signup to receive the latest properties',
};
